import '../../stylesheets/ProfilePage.css';
import React, { useState, useEffect } from 'react';
import { selectAllStrings, selectCurrentLanguage, languageChanged } from '../language/languageSlice';
import { selectUserData, selectDeviceIds, fetchUserData, fetchDevices,
        selectDeviceById, turnDevice, deleteDevice, loggedOut, isLoggedIn } from './userSlice';
import { selectPreferredPoiIds, selectPreferredPoiById, fetchPreferredPois, markFavorite } from '../pois/poisSlice';
import { selectUserReviewIds, selectUserReviewById, fetchUserReviews, deleteReview } from '../reviews/reviewsSlice';
import { selectUserPhotoIds, selectUserPhotoById, fetchUserPhotos, deletePhoto } from '../gallery/gallerySlice';
import { useSelector, useDispatch } from 'react-redux';
import Navbar from '../../app/Navbar';
import { getCardStatus } from '../../api/mobile';
import { FormatDate } from '../../lib/date-helper';
import { Link } from 'react-router-dom';
import PoisSlider from '../pois/PoisSlider';
import ReviewList from '../reviews/ReviewList';
import ToggleButton from '../../app/ToggleButton';
import constants from '../../constants';
import AskModal from '../../app/AskModal';
import ShareDialog from '../../app/ShareDialog';
import ReviewModal from '../reviews/ReviewModal';
import { useHistory } from 'react-router-dom';
import { PoiRating } from '../pois/PoiList';
import ImageList from '../gallery/ImageList';
import BuyAccessButton from '../../components/BuyAccessButton';

let Device = ({deviceId, onDelete}) => {
    const device = useSelector((state) => selectDeviceById(state, deviceId));
    const [turnedOn, setTurnedOn] = useState(device.pr_attivo == 1 ? true : false);
    const strings = useSelector(selectAllStrings);
    const cardData = useSelector(state => state.user.cardData);
    const dispatch = useDispatch();

    const onStateChanged = (event) => {
        setTurnedOn(!turnedOn);
        dispatch(turnDevice({profileId: deviceId, status: event.target.checked}));
    };



    return <div className="device">
        <div className="user-agent">{device.pr_useragent ? device.pr_useragent : 'unknown'}</div>
    
        {cardData.profile_id != deviceId ? <span className="delete" onClick={onDelete}>{strings.delete}</span> : null}
    </div>;
};
Device = React.memo(Device);

const ProfilePage = () => {
    const strings = useSelector(selectAllStrings);
    const [showAskModal, setShowAskModal] = useState(false);


    const cardData = useSelector(state => state.user.cardData);

    const profile = useSelector(selectUserData);
    const profileStatus = useSelector(state => state.user.userData.status);
    const profileError = useSelector(state => state.user.userData.error);

    const deviceIds = useSelector(selectDeviceIds);
    const devicesStatus = useSelector(state => state.user.devices.status);
    const devicesError = useSelector(state => state.user.devices.error);

    const preferredPoiIds = useSelector(selectPreferredPoiIds);
    const preferredPoisStatus = useSelector(state => state.pois.preferredPois.status);
    const preferredPoisError = useSelector(state => state.pois.preferredPois.error);

    const reviewIds = useSelector(selectUserReviewIds);
    const reviewsStatus = useSelector(state => state.reviews.byUser.status);
    const reviewsError = useSelector(state => state.reviews.byUser.error);

    const imageIds = useSelector(selectUserPhotoIds);
    const imagesStatus = useSelector(state => state.gallery.byUser.status);
    const imagesError = useSelector(state => state.gallery.byUser.error);

    const [modalQuestion, setModalQuestion] = useState('');



    const [cardStatus, setCardStatus] = useState(null);
    const currentLanguage = useSelector(selectCurrentLanguage);

    const [showShare, setShowShare] = useState(false);
    const loggedIn = useSelector(isLoggedIn);
    const history = useHistory();
    let shareLink;
    if (window.webkit && window.webkit.messageHandlers &&
            window.webkit.messageHandlers.getData) {
        shareLink = 'https://www.pleinairclub.it/app';
    } else {
        shareLink = 'share';
    }

    const openShareDialog = (event) => {

        if (navigator.share) {
            event.preventDefault();
            navigator.share({
                text: strings.it_very_usefull,
                url: shareLink
            }).then(() => {
                console.log('Thanks for sharing!');
            })
                    .catch(console.error);
        }
    };
    const closeShareDialog = (event = null) => {
        if (event !== null) {
            event.preventDefault();
        }
        setShowShare(false);
    };


    const [deviceToDelete, setDeviceToDelete] = useState(null);

    const [reviewToDelete, setReviewToDelete] = useState(null);

    const [onConfirmDeleting, setOnConfirmDeleting] = useState(null);

    const [askProps, setAskProps] = useState(null);

    const dispatch = useDispatch();
    const defaultReviewsLimit = 1;
    const defaultImagesLimit = 1;
    const [reviewsLimit, setReviewsLimit] = useState(defaultReviewsLimit);
    const [imagesLimit, setImagesLimit] = useState(defaultImagesLimit);


    const onDeleteDevice = (deviceId) => {
        setAskProps({
            question: strings.sure_delete_device,
            onConfirm: () => {
                dispatch(deleteDevice(deviceId));
                setAskProps(null);
            }
        });

    };

    const [cardRequestStatus, setCardRequestStatus] = useState('idle');


    useEffect(async () => {
        let status;
        if (cardRequestStatus === 'idle') {
            status = await getCardStatus();
            setCardStatus(status);
            setCardRequestStatus('fullfilled');
        }
        if (cardStatus !== null && profileStatus === 'idle' && loggedIn) {
            dispatch(fetchUserData({cardNumber: cardStatus.cardNumber, password: cardStatus.password}));
        }
        if (cardStatus !== null && devicesStatus === 'idle' && loggedIn) {
            dispatch(fetchDevices(cardStatus.cardNumber));
        }
        if (cardStatus !== null && imagesStatus === 'idle' && loggedIn) {
            dispatch(fetchUserPhotos(cardStatus.cardNumber));
        }



    }, [dispatch, profileStatus, cardData, profile, cardStatus, imagesStatus]);

    useEffect(() => {
        if (preferredPoisStatus === 'idle' && cardData.profile_id) {
            dispatch(fetchPreferredPois(cardData.profile_id));
        }
    }, [dispatch, preferredPoisStatus]);

    useEffect(() => {
        if (reviewsStatus === 'idle' && cardData.profile_id) {
            dispatch(fetchUserReviews(cardData.profile_id));
        }
    }, [dispatch, reviewsStatus]);





    const changeLanguage = (event, language) => {
        event.preventDefault();
        dispatch(languageChanged({language: language}));
    };

    const onLogoutClicked = (event) => {
        event.preventDefault();
        dispatch(loggedOut());
        localStorage.removeItem('href');
        localStorage.removeItem('loggedIn');
        localStorage.setItem('trialStatus', 'idle');
        //history.push('/');
    };





    const onDeletePoi = (event, poiId) => {
        event.preventDefault();
        event.stopPropagation();
        dispatch(markFavorite({userId: cardData.profile_id, poiId: poiId, add: false}));
    };

    const seeAllReviews = (event) => {
        event.preventDefault();
        setReviewsLimit(reviewIds.length);
    };

    const seeAllImages = (event) => {
        event.preventDefault();
        setImagesLimit(imageIds.length);
    };

    const seeLessReviews = (event) => {
        event.preventDefault();
        setReviewsLimit(defaultReviewsLimit);
    };

    const seeLessImages = (event) => {
        event.preventDefault();
        setImagesLimit(defaultImagesLimit);
    };





    return <section>
        {profileError ? <div>{profileError}</div> :
                        profileStatus === 'loading' || profileStatus === 'idle' ? <div className="loader"></div> :
                    <div id="profile_page">
                        {cardData.profile_id ? <div className="content">
                            {profile.user && profile.user.data.user_email.includes('@bitage.com')
                                                            && cardData.inapp_user == 1 ? <div>
                                                                <h1>{strings.profile_page}</h1>
                                                                <p>{strings.want_to_customize}</p>
                                                                <Link to={'/ios-registration'} className="btn">{strings.register_now}</Link>
                                                            </div> :
                                                <React.Fragment>
                                                    <h1>{profile.user ? `${profile.first_name} ${profile.last_name}` : null}</h1>
                                                    <h3>{strings.personal_information}</h3>
                                    
                                                    {cardData.inapp_user == 1 ? null :
                                                                            <React.Fragment>
                                                                                <div className="label">{strings.card_number}</div>
                                                                                <div className="value">{cardStatus ? cardStatus.cardNumber : null}</div>
                                                                            </React.Fragment>}
                                    
                                    
                                                    <div className="label">{strings.expiration_date}</div>
                                                    <div className="value">{profile.expire_card ? <FormatDate date={profile.expire_card} showDay={false}/> : null}</div>
                                                    <div className="label">{strings.cf}</div>
                                                    <div className="value">{profile.mepr_codice_fiscale}</div>
                                    
                                                    <h3>{strings.contact_information}</h3>
                                                    <div className="label">{strings.phone_number}</div>
                                                    <div className="value">{profile.mepr_telefono_online}</div>
                                                    <div className="label">{strings.email_address}</div>
                                                    <div className="value">{profile.user ? profile.user.data.user_email : null}</div>
                                                </React.Fragment>
                            }
                            <h3>{strings.device_management}</h3>
                            {devicesStatus === 'loading' ? <div className="loader"></div> : devicesStatus === 'succeeded' ?
                                                <div className="device-list">
                                                    {deviceIds.map(deviceId => <Device deviceId={deviceId} key={deviceId} onDelete={() => onDeleteDevice(deviceId)}/>)}
                                                </div> : devicesStatus === 'error' ? <div>{devicesError}</div>
                                                            : null}
                        </div>
                                        :
                                        <div id="personal_information" className="content">
                                            <h1>{strings.profile_page}</h1>
                                            <h3>{strings.personal_information}</h3>
                                            {strings.you_using_trial}
                                            <BuyAccessButton/>
                                        </div>}
                        <div className="content">
                            <h2>{strings.share_app}</h2>
                            <div className="button-list">
                                <a id="social" onClick={openShareDialog} href={shareLink} target="_blank">{strings.share_with_friends}</a>
                            </div>
                        </div>
                        {cardData.profile_id ? <div className="preferred-pois">
                            <h2 className="title">{strings.preferred_pois}</h2>
                            <Link className="see-all" to={'/preferred-pois'}>{strings.see_more}</Link>
                            <PoisSlider poiIds={preferredPoiIds} status={preferredPoisStatus} error={preferredPoisError}
                                        selectById={selectPreferredPoiById} layout="trending" showControls={true}
                                        onDelete={onDeletePoi}
                                        />
                        </div> : null}
                        {cardData.profile_id ? <div className="content">
                            <div className="reviews">
                                <h2>{reviewIds.length ? strings.your_reviews.replace('{number}', reviewIds.length) : null}</h2>
                                {reviewIds.length > reviewsLimit ? <a href="#" className="see-all" onClick={seeAllReviews}>{strings.see_all}</a> : null}
                
                                <ReviewList reviewIds={reviewIds} reviewsStatus={reviewsStatus} reviewsLimit={reviewsLimit} 
                                            reviewsError={reviewsError} selectById={selectUserReviewById} showControls={true}
                                            forceShowControls={true}
                                            />
                                {reviewIds.length == reviewsLimit ? <a href="#" className="see-less" onClick={seeLessReviews}>{strings.see_less}</a> : null}
                            </div>
                            <div className="uploads">
                                <h2>{imageIds.length ? strings.your_uploads.replace('{number}', imageIds.length) : null}</h2>
                                {imageIds.length > imagesLimit ? <a href="#" className="see-all" onClick={seeAllImages}>{strings.see_all}</a> : null}
                                {imagesStatus === 'loading' ? <div className="loader"></div> : imagesStatus === 'succeeded' ?
                                                <ImageList imageIds={imageIds} imagesLimit={imagesLimit} forceShowControls={true}/> : devicesStatus === 'error' ? <div>{imagesError}</div>
                                                                : null}
                                {imageIds.length == imagesLimit ? <a href="#" className="see-less" onClick={seeLessImages}>{strings.see_less}</a> : null}
                            </div>
                        </div> : null}
                
                        <div className="bottom-buttons content">
                            <button className="btn" id="language" onClick={event => changeLanguage(event, currentLanguage == 'en' ? 'it' : 'en')}>{currentLanguage == 'en' ? strings.app_in_italiano : strings.app_in_english}</button>
                            {constants.environment == 'iOS' ? null :
                                        <React.Fragment>
                                            <a className="btn" id="tutorial" href="https://www.pleinairclub.it/" target="_blank">{strings.tutorial}</a>
                                            <a className="btn" id="terms" href="https://www.pleinairclub.it/privacy-app" target="_blank">{strings.terms_and_conditions}</a>
                                            <a className="btn" id="privacy" href="https://www.pleinairclub.it/privacy" target="_blank">{strings.privacy}</a>
                                        </React.Fragment>
                            }
                            <button className="btn" id="logout" onClick={onLogoutClicked}>{strings.logout}</button>
                            <span>V. 1.9.10</span>
                        </div>
                
                    </div>}
        {askProps ? <AskModal message={askProps.question} onConfirm={askProps.onConfirm} onCancel={() => setAskProps(null)} /> : null}
        {showShare ? <ShareDialog link={shareLink} onClose={closeShareDialog} /> : null}
        <Navbar/>
    </section>
};

export default ProfilePage;